import classNames from 'classnames';
import { useCallback, useState } from 'react';
import { MaterialIcon } from 'shared/ui/MaterialIcon';

import style from './YearWrapper.module.scss';

interface YearWrapperProps {
  children: JSX.Element;
  year: string;
  titleClassName?: string;
  arrowClassName?: string;
  isShadow?: boolean;
}

export function YearWrapper({ children, year, titleClassName, arrowClassName, isShadow }: YearWrapperProps) {
  const [isOpen, setIsOpen] = useState(true);
  const [isSticked, setIsSticked] = useState(true);

  const onRefChange = useCallback((node: Element | null) => {
    if (node === null) {
      return;
    }

    const observer = new IntersectionObserver(
      ([event]) => {
        setIsSticked(event.intersectionRatio < 1);
      },
      { threshold: [1] }
    );

    observer.observe(node);
  }, []);

  return (
    <div className="relative">
      <div
        className={classNames(
          { [style.shadow]: isSticked || isShadow },
          'flex cursor-pointer select-none justify-between h-[65px] sticky z-10 bg-white items-center top-[-0.01px] relative'
        )}
        ref={onRefChange}
        onClick={() => setIsOpen((isOpen) => !isOpen)}
      >
        <div className={classNames(titleClassName, 'text-lg font-semibold')}>{year} Holiday Calendar</div>
        <MaterialIcon
          className={classNames(
            arrowClassName,
            'material-icons-outlined cursor-pointer select-none text-[24px] text-slate-700 opacity-100',
            { 'rotate-180': !isOpen }
          )}
        >
          expand_less
        </MaterialIcon>
      </div>
      <div className={classNames({ hidden: !isOpen })}>{children}</div>
    </div>
  );
}
